var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.SelectGroup,{attrs:{"label":_vm.field.label,"placeholder":_vm.field.placeholder || _vm.field.label,"options":_setup.computedOptions,"value":_vm.value},on:{"update":function($event){return _vm.$emit('update', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }